import { render, staticRenderFns } from "./OcupationRate.vue?vue&type=template&id=d5591bf4&scoped=true&"
import script from "./OcupationRate.vue?vue&type=script&lang=ts&"
export * from "./OcupationRate.vue?vue&type=script&lang=ts&"
import style0 from "./OcupationRate.vue?vue&type=style&index=0&id=d5591bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5591bf4",
  null
  
)

export default component.exports